document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq__item').forEach((item) => {
        item.addEventListener('toggle', function () {
            if (this.open) {
                document.querySelectorAll('.faq__item').forEach((other) => {
                    if (other !== this && other.open) {
                        other.open = false;
                    }
                });
            }
        });
    });
});
